"use client";

import { Toaster } from "sonner";
import NextjsTopLoader from "nextjs-toploader";
import { CheckCircle2, XCircle } from "lucide-react";

export default function ClientLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <>
      <NextjsTopLoader color="#ff5900" height={3} showSpinner={false} />
      {children}{" "}
      <Toaster
        toastOptions={{
          style: {
            background: "var(--card)",
            color: "var(--foreground)",
            border: "1px solid var(--border)",
            borderRadius: "0.5rem",
            fontFamily: "var(--font-body)",
            fontSize: "0.875rem",
          },
          classNames: {
            toast: "!border !border-border !bg-card !text-foreground",
            title: "!font-heading !font-semibold !text-foreground",
            description: "!text-muted-foreground !text-xs",
            success: "!border-l-4 !border-l-primary",
            error: "!border-l-4 !border-l-accent",
          },
        }}
        icons={{
          success: <CheckCircle2 className="h-5 w-5 text-primary" />,
          error: <XCircle className="h-5 w-5 text-primary" />,
        }}
      />
    </>
  );
}
